import { createClient } from '@supabase/supabase-js';

// Declare global constants injected by Vite
declare const __SUPABASE_URL__: string;
declare const __SUPABASE_ANON_KEY__: string;

// Access environment variables with fallback to injected globals
const metaEnv = (import.meta as any).env || {};

// 1. Try Meta Env (Dev)
let rawUrl = metaEnv.VITE_SUPABASE_URL;
let rawKey = metaEnv.VITE_SUPABASE_ANON_KEY;

// 2. Try Injected Globals (Prod Build)
if (!rawUrl) {
    try { rawUrl = __SUPABASE_URL__; } catch(e) {}
}
if (!rawKey) {
    try { rawKey = __SUPABASE_ANON_KEY__; } catch(e) {}
}

const SUPABASE_URL = (rawUrl || '').trim();
const SUPABASE_KEY = (rawKey || '').trim();

// Check if both are present and valid
export const isSupabaseConfigured = !!SUPABASE_URL && !!SUPABASE_KEY;

// If configured, use real credentials. 
// If NOT configured, use placeholders to prevent the client from hitting the real URL without a key.
const urlToUse = isSupabaseConfigured ? SUPABASE_URL : 'https://placeholder.supabase.co';
const keyToUse = isSupabaseConfigured ? SUPABASE_KEY : 'placeholder-key';

export const supabase = createClient(urlToUse, keyToUse);

export const handleGoogleLogin = async () => {
  if (!isSupabaseConfigured) {
    alert("Supabase ist nicht konfiguriert. Login nicht möglich.");
    return;
  }
  await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: window.location.origin
    }
  });
};

export const handleFacebookLogin = async () => {
  if (!isSupabaseConfigured) {
    alert("Supabase ist nicht konfiguriert. Login nicht möglich.");
    return;
  }
  await supabase.auth.signInWithOAuth({
    provider: 'facebook',
    options: {
      redirectTo: window.location.origin
    }
  });
};